/**
 * ActionTable.cellClasses — shared cell-width constants for ActionTable's
 * row components.
 *
 * Split out from ActionTable.helpers.tsx so row-component modules (here and
 * in MixedActionTable) can import the constants without circular
 * dependencies.
 */

/**
 * Width overrides for the narrow "chrome" columns — chevron, checkbox,
 * avatar, status. `!` prefix beats the default `px-5 py-3` (size='sm') and
 * `px-6 py-4` (size='md') padding baked into `Table.Cell`.
 */
export const ACTION_TABLE_CHROME_CELL_CLASSES = '!w-12 !px-3';
export const ACTION_TABLE_AVATAR_CELL_CLASSES = '!w-12 !px-2';

/**
 * Data cells cap at 200px so long strings (company names, titles, addresses)
 * truncate with an ellipsis rather than pushing adjacent columns off-screen.
 * `whitespace-nowrap` + `overflow-hidden` + `text-ellipsis` together give the
 * classic single-line truncation look that matches the rest of the app's
 * table cells.
 */
export const ACTION_TABLE_DATA_CELL_CLASSES =
  'max-w-[200px] whitespace-nowrap overflow-hidden text-ellipsis';
